import { Spinner } from './Spinner';

interface InlineLoaderProps {
  /** What is loading, printed exactly as given: "Loading attendance…". */
  label: string;
  /** 'xs' where the line around it is small print (text-xs), so the words keep that size. */
  size?: 'sm' | 'xs';
  className?: string;
}

const classesOf = (className: string): string[] => className.split(/\s+/).filter(Boolean);

/**
 * One line: the ring, then the words. For inside a card, a table cell or a section.
 *
 * It sits in the line like the text it replaces, so it follows the text-center of the
 * cell or block around it and may go anywhere a word may, a paragraph included.
 * To centre it in a block of its own: className="flex justify-center py-8". A caller's
 * own `flex` REPLACES the default `inline-flex` instead of joining it: two display
 * classes on one element are settled by the order Tailwind emits them, and `inline-flex`
 * is emitted after `flex`.
 */
export function InlineLoader({ label, size = 'sm', className = '' }: InlineLoaderProps) {
  const display = classesOf(className).includes('flex') ? '' : 'inline-flex';
  return (
    <span role="status" className={`${display} items-center gap-2 ${className}`.trim()}>
      <Spinner size={size} />
      <span className={`${size === 'xs' ? 'text-xs' : 'text-sm'} text-gray-500`}>{label}</span>
    </span>
  );
}
